import { pickDocument } from "../framework/uploader";

$(document)
  .on("click", ".module-scorm-page form .btn-raised", onLoadFile)
  .on("click", ".module-scorm-page .select-scorm", onSelectScorm);

function onLoadFile(e) {
  e.preventDefault();

  let $form = $(this).closest("form");
  let storagePath = $(this).data("storage-path");

  if ($form.find("input.scorm-name").val().trim().length == 0) return;

  pickDocument(storagePath, function (success, key) {
    if (!success) return;

    $form.find("input.file-url").val(key);

    $form.trigger("submit");
  });
}

function onSelectScorm(e) {
  e.preventDefault();
  let scormId = $(this).data("scorm-id");
  let $form = $(".module-scorm-page form");
  $form.append(`<input type="hidden" name="scorm_id" value="${scormId}"/>`);
  $form.find(".file-url").remove();
  $form.find(".scorm-name").remove();
  $form.find(".scorm-description").remove();
  $form.trigger("submit");
}
